import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Icon, Card } from 'semantic-ui-react';
import i18next from 'i18next';
import { setEditedEntity } from '../../../actions';

class MenuActions extends Component {
    render() {
        const { menuId, editInfo } = this.props;

        return (
            <Card style={{ width: 'fit-content' }}>
                <Card.Content style={{ padding: 10 }}>
                    <Card.Meta>{`[${menuId}] ${i18next.t('menu.lastEdit', { name: editInfo.lastEditor, time: new Date(editInfo.lastEditAt).toLocaleString() })}`}</Card.Meta>
                </Card.Content>
                {this.props.mode === 'items' ?
                    <Card.Content style={{ padding: 5 }}>
                        <Button primary basic onClick={() => this.props.setEditedEntity('menuItem', { menuId })}>
                            <Icon name='add' /> {i18next.t('menu.createItem')}
                        </Button>
                        <Button basic onClick={() => this.props.toggleMode('categories')}>
                            <Icon name='sitemap' /> {i18next.t('menu.navToCategories')}
                        </Button>
                        <Button basic onClick={() => this.props.toggleMode('translations')}>
                            <Icon name='translate' /> {i18next.t('translateMenu')}
                        </Button>
                        <Button icon="refresh" basic color={editInfo.conflict ? 'red' : undefined} onClick={this.props.onRefresh} />
                    </Card.Content>
                    :
                    <Card.Content style={{ padding: 5 }}>
                        <Button primary basic onClick={() => this.props.setEditedEntity('menuCategory', { menuId, type: 'primary' })}>
                            <Icon name='add' /> {i18next.t('menu.newCategory')}
                        </Button>
                        <Button basic onClick={() => this.props.toggleMode('items')}>
                            <Icon name='table' /> {i18next.t('menu.navToItems')}
                        </Button>
                        <Button basic onClick={() => this.props.toggleMode('translations')}>
                            <Icon name='translate' /> {i18next.t('translateMenu')}
                        </Button>
                        <Button icon="refresh" basic color={editInfo.conflict ? 'red' : undefined} onClick={this.props.onRefresh} />
                    </Card.Content>
                }
            </Card>
        );
    }
}

MenuActions.propTypes = {
    mode: PropTypes.string,
    editInfo: PropTypes.object,
    toggleMode: PropTypes.func,
    menuId: PropTypes.string,
    setEditedEntity: PropTypes.func,
    onRefresh: PropTypes.func
    
};

export default connect(null, { setEditedEntity })(MenuActions);

